export default {
  excel: {
    exportModalTitle: 'Export data',
    fileType: 'File type',
    fileName: 'File name',
    exportCurrent: 'Export Current',
    exportAll: 'Export All',
    export: "Export"
  },
  form: {
    putAway: 'Put away',
    unfold: 'Unfold',
    maxTip: 'The number of characters should be less than {0}',
    apiSelectNotFound: 'Wait for data loading to complete...',
  },
  table: {
    settingDens: 'Density',
    settingDensDefault: 'Default',
    settingDensMiddle: 'Middle',
    settingDensSmall: 'Compact',
    settingColumn: 'Column settings',
    settingColumnShow: 'Column display',
    settingIndexColumnShow: 'Index Column',
    settingFixedLeft: 'Fixed Left',
    settingFixedRight: 'Fixed Right',
    settingFullScreen: 'Full Screen',
    settingBordered: 'Bordered',
    index: 'Index',
    total: 'total of {total}',
    allLabel: 'All',
    YesLabel: 'Yes',
    NoLabel: 'NO',
    settingOrder: 'Order setting',
    union: 'union',
    confirm: 'confirm',
    cancel: 'cancel',
    Ascending: 'Ascending',
    Descending: 'Descending',
    singleAscending: 'single Ascending',
    fullScreen: 'full screen',
    exitFullScreen: 'Exit full screen',
    IntWarning: 'Please input int number in {1}',
    LengthWarning: "{1}'length is larger then max,please check",
    FloatWarning: 'Please float int number in {1}',
    batchQueryItem: 'Query by batch',
    selectColInfo: 'Please select query cols',
    editInDlg: 'Edit in dialog',
    show: 'show',
    showInDlg: 'Detils info',
    validWarning: "Please check the form data",
    InputWarn: "InputWarn",
    SelectWarn: "Please select"
  },
};
